export default "__VITE_ASSET__CQIGmHlY__"